<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <div class="btn-toolbar pull-right">
          <div class="btn-group">
            <a class="btn btn-primary btn-sm btn-action" href="#!/usuarios/new" uib-tooltip="Novo Usuário" tooltip-placement="left" ng-if="permissions.usuario.canManage">
              Novo <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <h2>Usuários</h2>
      </div>
    </div>
  </div>

  <div class="row" ng-include="'views/usuarios/_filtros.html'"></div>
  <div class="row" ng-include="'views/usuarios/_list.html'"></div>
</page-data-manager>
